export const TOAST_DURATION = 5000;
